<div class="stepper h-100 overflow-auto">
    <div *ngFor="let step of steps" class="step" 
        (click)="change(step)" #stepRef
        [class.active]="step === selectedStep">
        {{ step }}
    </div>
</div>